import Common from "../../Common";
import { FileType } from "../../Enums";
import Member from "./cdr/Member";

const Cdr = class extends Common {
	member: InstanceType<typeof Member>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.member = new Member(headers);
	}

	async browse(id: id) {
		return this.get(`/queue/${id}/cdr`);
	}

	async download(
		type: FileType,
		options?: {
			'queues[]'?: any,
			datetime_from?: string,
			datetime_to?: string,
			limit?: number,
			responseType?: string,
		}
	) {
		return this.get(
			`/queue/cdr/download/${type}`,
			options,
			{ responseType: options?.responseType ?? 'blob' }
		);
	}

	async search(
		options?: {
			'queues[]'?: any,
			datetime_from?: string,
			datetime_to?: string,
			limit?: number,
			limit_from?: number,
		}
	) {
		return this.get(`/queue/cdr`, options);
	}
}

export default Cdr
